<template>
  <div class="edit">
    <h1>Fundering types</h1>

    <form class="default-form edit-form" @submit.prevent="">

      <div class="default-form-field">

        <div class="default-form-field-types row" style="flex-direction: row; text-align: left;">
          <span class="item row-header">Naam</span>
          <span class="item row-header">Artikelcode</span>
          <span class="item row-header">Label</span>
          <span class="item row-header">Beschrijving</span>
          <span class="item row-header">uiImage</span>
          <span class="item row-header">Infobox</span>
          <span class="item row-header">poeren aan?</span>
          <span class="item row-header">vloer aan?</span>
          <span class="item row-header">vloer material</span>
          <span class="item row-header">default</span>
          <span class="item row-header"></span>

          <div v-for="(fundering, i) in funderingTypes" :key="i" class="default-form-field-types-edit-row row">
            <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="fundering.name" @keydown.enter="add(i + 1)">

            <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="fundering.artikelCode" @keydown.enter="add(i + 1)">

            <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="fundering.label" @keydown.enter="add(i + 1)">
            <input type="text" class="default-form-field-input item" :id="'input' + i" v-model.trim="fundering.description" @keydown.enter="add(i + 1)">

            <select v-model="fundering.uiImage" class="default-form-field-input item">
              <option v-for="(texture, j) in texturesWithEmpty" :key="'diff'+i+'-'+j" :value="texture.id">{{texture.name}}</option>
            </select>

            <div class="item">
              <select v-model="fundering.infobox" class="default-form-field-input" style="width: 100%">
                <option v-for="(infobox, j) in infoboxesWithEmpty" :key="'diff'+i+'-'+j" :value="infobox.id">{{infobox.name}}</option>
              </select>
            </div>

            <div class="item">
              <input class="checkbox" type="checkbox" :id="`poerenEnabled`+i" name="poerenEnabled-checkbox" v-model="fundering.poerenEnabled">
              <label :for="`poerenEnabled`+i" class="checkbox-label sizes-form-checkbox" style="float: none; display: inline-flex; margin-right:40px">
                <mdicon name="check-bold" class="checkbox-label-icon" :class="fundering.poerenEnabled ? 'checkbox-label-icon-active' : ''" size="15" />
              </label>
            </div>

            <div class="item">
              <input class="checkbox" type="checkbox" :id="`vloerEnabled`+i" name="vloerEnabled-checkbox" v-model="fundering.vloerEnabled">
              <label :for="`vloerEnabled`+i" class="checkbox-label sizes-form-checkbox" style="float: none; display: inline-flex; margin-right:40px">
                <mdicon name="check-bold" class="checkbox-label-icon" :class="fundering.vloerEnabled ? 'checkbox-label-icon-active' : ''" size="15" />
              </label>
            </div>

            <select v-model="fundering.vloerMaterial" class="default-form-field-input item">
              <option v-for="(texture, j) in materialsWithEmpty" :key="'normal'+i+'-'+j" :value="texture.id">{{texture.name}}</option>
            </select>

            <div class="item">
              <input class="checkbox" type="checkbox" :id="`isDefault`+i" name="isDefault-checkbox" v-model="fundering.isDefault" @change="updateIsDefault(fundering)">
              <label :for="`isDefault`+i" class="checkbox-label sizes-form-checkbox" style="float: none; display: inline-flex; margin-right:40px">
                <mdicon name="check-bold" class="checkbox-label-icon" :class="fundering.isDefault ? 'checkbox-label-icon-active' : ''" size="15" />
              </label>
            </div>

            <button class="default-form-field-button item" @mousedown="remove(i)" >
              <mdicon name="minus" class="default-form-field-button-icon" size="25" />
            </button>
          </div>

          <button class="default-form-field-button" @click="add(funderingTypes.length)">
            <mdicon name="plus" class="default-form-field-button-icon" size="25" />
          </button>
        </div>
      </div>

      <div class="default-form-button">
        <LoadingButton @click="update()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>

    </form>
  </div>
</template>

<script>
import isEqual from 'lodash.isequal'
import { mapGetters } from 'vuex'
import LoadingButton from '@/components/inputs/buttons/LoadingButton.vue'

export default {
  name: "FunderingTypes",

  components: {
    LoadingButton
  },

  data () {
    return {
      funderingTypes: [],
      formValid: false,
      loading: false,
    }
  },

  methods: {
    async get () {
      await Promise.all([
        this.$store.dispatch('getFunderingTypes'),
        this.$store.dispatch('getTextures'),
        this.$store.dispatch('getMaterials')
      ])
      this.funderingTypes = JSON.parse(JSON.stringify(this.data))
    },

    async update () {
      this.loading = true

      let remove = []
      let update = []
      let insert = []

      for (let i = 0; i < this.data.length; i++) {
        const keepId = this.funderingTypes.find((t) => t.id === this.data[i].id)
        if (!keepId) {
          // funderingType is removed
          remove.push(this.data[i])
        } else {
          const funderingTypeChanged = this.funderingTypes.find((t) => t.id === this.data[i].id && JSON.stringify(t) !== JSON.stringify(this.data[i]))
          if (funderingTypeChanged) {
            // funderingType is changed
            update.push(funderingTypeChanged)
          }
        }
      }

      for (let i = 0; i < this.funderingTypes.length; i++) {
        if (!this.funderingTypes[i].id) {
          insert.push(this.funderingTypes[i])
        }
      }

      try {
        await this.$store.dispatch('updateFunderingTypes', {
          remove: remove,
          update: update,
          insert: insert
        })
      } catch (err) {
        console.log(err)
        this.loading = false
      }

      this.loading = false
      this.funderingTypes = JSON.parse(JSON.stringify(this.data))
    },

    add (i) {

      if (i === this.funderingTypes.length) {
        this.funderingTypes.push({
          id: null,
          name: "",
          label: "",
          description: "",
          poerenEnabled: false,
          vloerEnabled: false,
        })
      }

      this.$nextTick(() => {
        document.getElementById('input' + (i)).focus()
      })
    },

    remove (i) {
      this.funderingTypes.splice(i, 1)
    },

    updateIsDefault (fundering) {
      // Reset all isDefault to false except the one that was just clicked
      this.funderingTypes.forEach(f => {
        if (f !== fundering) {
          f.isDefault = false
        }
      })
    }
  },

  computed: {
    ...mapGetters({
      data: "getFunderingTypes",
      textures: 'getTextures',
      materials: 'getMaterials',
      infoboxes: 'getInfoboxes'
    }),

    texturesWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.textures]
    },

    materialsWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.materials]
    },

    infoboxesWithEmpty () {
      return [{ id: null, name: '(leeg)' }, ...this.infoboxes]
    }
  },

  created () {
    this.get()
  },

  watch: {
    funderingTypes: {
      deep: true,
      immediate: false,
      handler () {
        if (isEqual(this.funderingTypes, this.data)) {
          this.formValid = false
        } else {
          this.formValid = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit {
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  min-width: min(100%, 800px);

  &-form {
    padding: 25px 0px;
    gap: 50px;
    width: 90%
  }
}

.row {
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap if needed */
  width: 100%; /* Adjust as necessary */
  &-header {
    padding-left: 5px;
    justify-content: left !important;
  }
}

.item {
  flex: 1; /* Default flex property for other items */
  width: 0px; // dit werkt op een of andere manier
  box-sizing: border-box; /* Include padding and border in width */
  display: flex;
  align-items: center;
  // justify-content: center;
  // &:nth-child(1) {
  //   flex: 0 0 300px; /* Fixed width of 70px */
  // }
  // &:nth-child(2) {
  //   flex: 0 0 300px; /* Fixed width of 70px */
  // }
  &:nth-child(2) {
    flex: 0 0 100px; /* Fixed width of 70px */
  }
  &:nth-child(5) {
    flex: 0 0 300px; /* Fixed width of 70px */
  }
  &:nth-child(6) {
    flex: 0 0 150px; /* Fixed width of 70px */
  }
  &:nth-child(7) {
    flex: 0 0 150px; /* Fixed width of 70px */
  }
  &:nth-child(8) {
    flex: 0 0 300px; /* Fixed width of 100px */
  }
  &:nth-child(9) {
    flex: 0 0 60px; /* Fixed width of 30px */
  }
  &:nth-child(10) {
    flex: 0 0 30px; /* Fixed width of 30px */
  }
  //&:nth-child(n+4):nth-child(-n+8) {
  //  flex: 1; /* Allow remaining items to grow */
  //}
}

</style>